function RequestNewItemModalController(
    $scope,
    $uibModalInstance,
    callback
) {
    this.modalInstance = $uibModalInstance;
    this.callback = callback;

    $scope.doNotShowAgain = false;

    $scope.cancel = () => {
        this.modalInstance.close();
    }

    $scope.ok = () => {
        if($scope.doNotShowAgain) {
            localStorage.setItem("do-not-show-request-new-item", true);
        }

        this.callback();
        this.modalInstance.close();
    }
}

angular.module('dashboard')
    .controller('RequestNewItemModalController',
        [
            '$scope',
            '$uibModalInstance',
            'callback',
            RequestNewItemModalController
        ])


